export const PERMISSION_SCOPES = {
  TAX_SUPERVISOR: "TAX_SUPERVISOR",
  ADMIN: "ADMIN",
  CLERK: "CLERK",
  ACCOUNTING: "ACCOUNTING",
  READONLY: "READONLY",
  DIY: "DIY",
  INVALID: "INVALID",
} as const;

export type PermissionScope =
  (typeof PERMISSION_SCOPES)[keyof typeof PERMISSION_SCOPES];

export interface Operator {
  id: string;
  name: string;
  email: string;
  permissionScope: PermissionScope;
  exp: number; // Expiration timestamp
}

export interface AuthContextType {
  operator: Operator | null;
  loading: boolean;
  login: () => void;
  error: string | null;
  logout: () => void;
}

export const TAX_ADVISORY_PERMISSION_SCOPES = [
  PERMISSION_SCOPES.TAX_SUPERVISOR,
  PERMISSION_SCOPES.ADMIN,
  PERMISSION_SCOPES.CLERK,
  PERMISSION_SCOPES.ACCOUNTING,
  PERMISSION_SCOPES.READONLY,
];
